export function content(label, ...args) {
    const safeLabel = String(label ?? '');
    return safeLabel.replace(/\{(\d+)\}/g, (_, index) => {
        const arg = args[parseInt(index, 10)];
        return typeof arg === 'string' || typeof arg === 'number' ? String(arg) : '';
    });
}
